class DBLedgerAccountsCoder extends DBXLSXCoder
{
    mainEntity() {
        return { entity: "LedgerAccount", predicateFormat: "deletedAt == null" }
    }

    columns() : any[] {
        let cols = [
            { title:"ACCOUNT", width: "10%", align: "center" },
            { title:"TITLE", width: "10%", align: "center" }
        ]
        return cols;
    }

    protected importRow(row:any){

        let prefix = row["ACCOUNT"];
        let name = row["TITLE"];

        if (prefix == null || String(prefix).trim().length == 0) { return; }
        prefix = String(prefix).trim();
        name = name != null ? String(name).trim() : prefix;

        let account = this.queryEntityByField("LedgerAccount", "prefix", prefix) as LedgerAccount;
        if (account == null) {
            account = MIOEntityDescription.insertNewObjectForEntityForName("LedgerAccount", DBHelper.mainManagedObjectContext) as LedgerAccount;
            account.identifier = this.parseOrCreateIdentifier(null);
            account.prefix = prefix;
        }

        account.name = name;

        this.appendObject(account);
        MIOLog("ADDING LEDGER ACCOUNT: " + this.rowIndex + "/" + this.rows.length + ": " + prefix + " " + name);
    }

    protected exportTitle() : string { return "LedgerAccount"; }

    protected exportSortDescriptors() { 
        return [MIOSortDescriptor.sortDescriptorWithKey("prefix", true), MIOSortDescriptor.sortDescriptorWithKey("name", true)]; 
    }

    protected parseObject(object:MIOManagedObject): any {
        let acc = object as LedgerAccount;

        let item = {
            "ACCOUNT" : acc.prefix,
            "TITLE"   : acc.name
        }

        return item;
    }
}